// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__dVoiP","Label":"Input_Label__zzrHF","InputElement":"Input_InputElement__3KK4E","Invalid":"Input_Invalid__3iW08"};